var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "grid-view" }, [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              ref: "searchItem",
              attrs: {
                "config-module": "1110",
                reset: true,
                "custom-sim-query-placeholder":
                  _vm.$t("CargoMsg.Cargo_PlsInput") +
                  _vm.$t("SeaExport.FlightNo")
              },
              on: {
                "click-more": function(value) {
                  _vm.isAdvancedQuery = value
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex" },
                  attrs: { slot: "operations" },
                  slot: "operations"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isAdvancedQuery,
                          expression: "!isAdvancedQuery"
                        }
                      ],
                      staticStyle: { "margin-right": "5px" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          placeholder:
                            _vm.$t("CargoMsg.Cargo_PlsInput") +
                            _vm.$t("SeaExport.FlightNo")
                        },
                        model: {
                          value: _vm.flightNo,
                          callback: function($$v) {
                            _vm.flightNo = $$v
                          },
                          expression: "flightNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.exportToExcel }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ExportToExcel")))]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "111001",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "auto-fit-content": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "pagination-wrapper",
              attrs: { id: "footer-wrapper" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "total-wrapper",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "flex-wrap": "wrap",
                    "margin-top": "10px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-content": "center",
                        "padding-left": "5px"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "font-size": "13px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_TotalCost") + "：")
                          )
                        ]
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.totalCost))])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-content": "center",
                        "padding-left": "5px"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "font-size": "13px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_TotalIncome") + "：")
                          )
                        ]
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.totalRevenue))])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-content": "center",
                        "padding-left": "5px"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "font-size": "13px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Profit") + "："))]
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.profit))])
                    ]
                  )
                ]
              ),
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "11100101",
                  total: _vm.total,
                  page: _vm.pageNum,
                  limit: _vm.pageSize
                },
                on: {
                  "update:page": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:limit": function($event) {
                    _vm.pageSize = $event
                  },
                  pagination: _vm.toPageQuery
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }